import React from 'react';

import { useHistory } from 'react-router-dom';
import IconMessenger from '../../common/IconMessenger.component';

import {
  Container,
  IconLabelContainer,
  HorizontalRule,
} from './ChannelDescriptionBanner.styles';

export default function ChannelDescriptionBannerMessenger() {
  const history = useHistory();
  return (
    <>
      <Container>
        <IconLabelContainer>
          <IconMessenger
            size={40}
          />

          <b>Messenger</b>
        </IconLabelContainer>

        <div>
          Os webhooks permitem que você crie integrações personalizadas,
          enviando informações para o seu servidor da web quando um determinado
          evento ocorre.
        </div>

        {/* Não está sendo utilizado por enquanto, mas vou deixar aqui caso queiramos reutilizar*/}
        {/* <Button
          color="primary"
          onClick={() => history.push('/tools/channels/add')}
          style={{
            width: '30rem',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <span
            style={{
              display: 'flex',
              gap: '0.1rem',
              alignItems: 'center',
            }}
          >
            <Icon icon={'poli-icon pi-add-line'} size={20} />
            <span> Adicionar Canal</span>
          </span>
          <Icon icon={'poli-icon pi-simple-arrow-down-line'} size={20} />
        </Button> */}
      </Container>
      <HorizontalRule />
    </>
  );
}
